/**
 * Reload the page if the current page is the route given as paramter
 *
 * @param [String] route the route we are trying to reload
 */
export function reloadIfCurrentRoute(route) {
  if (window && window.location.pathname === route) {
    window.location.href = route
  }
}
